import { initContract, ZodErrorSchema } from "@ts-rest/core";
import { Request } from "./request.js";
import { Err, Ok } from "./response.js";

export const contract = initContract().router({
  todos: {
    method: "GET",
    path: "/organisation/:organisationId/todos",
    pathParams: Request,
    responses: {
      [200]: Ok,
      [400]: ZodErrorSchema,
      [500]: Err,
    },
    summary: "Get a list of todos for the current organisation.",
  },
});
